"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSantanderApplicationStatusMutation = void 0;
const types_1 = require("../../types");
exports.updateSantanderApplicationStatusMutation = `
  mutation updateSantanderApplicationStatus($orderId: String!) {
    updateSantanderApplicationStatus(orderId: $orderId) {
      ...order
    }
  }
  ${types_1.orderApplicationStatusFragments}
`;
//# sourceMappingURL=application.js.map